import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { take, map } from 'rxjs/operators';
import { UserRole } from '../_interfaces/enums.interface';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    return this.authService.currentUser$.pipe(
      take(1),
      map(user => {
        if (!user) {
          return this.router.createUrlTree(['/auth/login']);
        }

        switch (user.role) {
          case UserRole.ADMIN:
            return this.router.createUrlTree(['/dashboard/admin']);
          case UserRole.STARTUP:
            return this.router.createUrlTree(['/dashboard/startup']);
          case UserRole.INCUBATOR:
            return this.router.createUrlTree(['/dashboard/incubator']);
          default:
            return this.router.createUrlTree(['/auth/login']);
        }
      })
    );
  }
}
